<div nz-row>
  <div nz-col nzSpan="6">
    <span class="pageTitle">Clarification Query</span>
  </div>
  <div nz-col nzSpan="8">
    <div class="search-container">
      <nz-input-group [nzPrefix]="searchIcon">
        <input nz-input type="text" placeholder="Enter minimum 3 characters to search..." [(ngModel)]="searchText"
          (input)="onSearch()" class="search-box" />
      </nz-input-group>
      <ng-template #searchIcon>
        <i nz-icon nzType="search"></i>
      </ng-template>


    </div>
  </div>
  <div nz-col nzSpan="10">
    <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
      <button *ngIf="currentUser.IsRFCAdmin" nz-button nzType="primary" style="margin-right: 10px;"
        [routerLink]="['/clarification-query/create-query']">
        <i nz-icon nzType="plus" nzTheme="outline" style="color: white;"></i> Submit new Query
      </button>
      <button nz-button *ngIf="filteredQueryRequest.length > 0" nzType="primary" (click)="exportToExcel()">
        <i nz-icon nzType="file-excel" nzTheme="outline" style="color: white;"></i> Export to Excel
      </button>
    </div>

  </div>
</div>


<nz-table *ngIf="currentUser.Is_Partner" #partnerTable [nzScroll]="{ x: '1200px' }" [nzData]="filteredQueryRequest"
  [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true">
  <thead>
    <tr>
      <th *ngFor="let column of partnerTableColumns" [nzSortFn]="sortString" [nzSortPriority]="column.priority"
        [nzShowSort]="column.showShort" style="padding: 1px 10px; font-size: 11px; font-weight: 100;width: 150px;">
        {{ column.title }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let query of partnerTable.data">
      <td style="height: 30px;">
        
        <div *ngIf="query.RequestorCode == currentUser.User_Code">
          <button nz-button nzType="primary" [nzSize]="'small'" *ngIf="(query.QueryStatusCode != queryResponseEnum
                              && query.QueryStatusCode != queryDeleteByAdminEnum
                              && query.QueryStatusCode != queryDeleteByPartnerEnum)" (click)="showDeleteConfirm(query)"
            value="Delete" style="font-size: 11px;">Delete</button>
          
          <button *ngIf="query.QueryStatusCode == queryResponseEnum" nz-button nzType="primary" style="margin-left: 5px;font-size: 11px;" [nzSize]="'small'"
            routerLink="/clarification-query/reopen-query/{{query.QueryCode}}" value="Re-Open">Re-Open</button>&nbsp;
        </div>
      </td>
      <td style="font-size: 80%;">

        <a class="referanceNumber" style="cursor: pointer; font-size: 12px; " [routerLink]="['/clarification-query/view-query', query.QueryCode]">
          <strong>{{query.QueryRequestNumber}}</strong>
        </a>

      </td>
      <td>{{query.Subject}}</td>
      <td>{{query.PartnerQueryStatus}}</td>
      <td>{{query.RequestorName}}</td>
      <td>{{query.CompanyName}}</td>
      <td>{{query.Block}}</td>
      <td>{{query.RequestedDate | date:'dd-MMM-yyyy' }}</td>
      <td>{{query.PriorityLevel}}</td>
      <td>{{query.Confidential}}</td>
      <td>{{query.Department}}</td>
      <td>{{query.SubDeptartment}}</td>
      <td>{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
      <td>{{query.CreatedByUserName}}</td>
    </tr>
  </tbody>
</nz-table>

<div id="divnonPartnerTable" style="width: 100%; overflow-x: auto; margin-top: 20px; border: 0px solid #ccc;">
  <div style="width: 2100px; height: 100%; display: flex; align-items: left; ">

<nz-table *ngIf="!currentUser.Is_Partner" #nonPartnerTable [nzData]="filteredQueryRequest"
  [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="true"  nzShowSizeChanger >
  <thead>
    <tr>
      <th *ngFor="let column of nonPartnerTableColumns" 
        [nzSortFn]="sortString" 
        [nzSortPriority]="column.priority"
        [nzShowSort]="column.showShort" 
        [nzSortDirections]="column.sortDirections"
        style="padding: 5px; font-size: 12px; font-weight: 100;" >
        {{ column.title }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let query of nonPartnerTable.data">
      <td>

        <div *ngIf="currentUser.IsRFCAdmin" class="button-container">
          <button nz-button nzType="primary" [nzSize]="'small'" *ngIf="(query.QueryStatusCode == queryAnsweredByDeptEnum || 
                          query.QueryStatusCode == queryAnsweredBySponsorEnum)"
            routerLink="/clarification-query/recycle-query/{{query.QueryCode}}" value="Recycle" style="margin-bottom: 5px; margin-right: 2px;">Recycle</button>
          <button nz-button nzType="primary" [nzSize]="'small'" *ngIf="(query.QueryStatusCode != queryResponseEnum 
                            && query.QueryStatusCode != queryDeleteByAdminEnum
                            && query.QueryStatusCode != queryDeleteByPartnerEnum)" (click)="showDeleteConfirm(query)"
            value="Delete">Delete</button>
        </div>
      </td>
      <td ><a class="referanceNumber" style="cursor: pointer; font-size: 11px; " routerLink="/clarification-query/view-query/{{query.QueryCode}}">
          {{query.QueryRequestNumber}}</a>
      </td>
      <td>{{query.Subject}}</td>
      <td><strong>{{query.QueryStatus}}</strong>
        <div *ngIf="(query.QueryStatusCode == queryAssgnToDepRepEnum || query.QueryStatusCode == queryRecycledEnum)">
          <small *ngFor="let name of query.QueryAssignedTo?.split('|')">
            {{ name }}
          </small>
        </div>
        <div
          *ngIf="(query.QueryStatusCode == queryAnsweredByDeptEnum || query.QueryStatusCode == queryAnsweredBySponsorEnum)">
          <small *ngFor="let name of query.QueryAnsBy?.split('|')">
            {{ name }}
          </small>
        </div>
      </td>
      <td>{{query.RequestorName}}</td>
      <td>{{query.RequestedDate | date:'dd-MMM-yyyy' }}</td>
      <td>{{query.Category}}</td>
      <td>{{query.SubCategory}}</td>
      <td>{{query.Block}}</td>
      <td>{{query.PriorityLevel}}</td>
      <td>{{query.Confidential}}</td>
      <td>{{query.Department}}</td>
      <td>{{query.SubDeptartment}}</td>
      <td>{{query.RespondedDate | date:'dd-MMM-yyyy hh:mm:ss a' }}</td>
      <td>{{query.CreatedByUserName}}</td>
      <td>{{query.QueryReqDueDate | date:'dd-MMM-yyyy hh:mm:ss a'}}</td>
    </tr>
  </tbody>
</nz-table>


    
  </div>
</div>
